import { ExternalLink, ShieldCheck } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { useText } from "@/lib/useText";
import { useStorePackages, VipSpotlight, PackagesGrid } from "@/components/site/StorePackages";

export default function Loja() {
  const { content } = useContent();
  const t = useText();
  const { store, links, media } = content;
  const packages = useStorePackages();
  const list = packages?.packages || [];

  return (
    <>
      <section className="relative flex min-h-[calc(100vh-4rem)] items-center overflow-hidden" aria-labelledby="loja-title" data-testid="store-page">
        {media.store_video_url ? (
          <video className="absolute inset-0 h-full w-full object-cover" autoPlay muted loop playsInline preload="metadata" poster={media.store_poster_url || undefined} aria-hidden="true" data-testid="store-video">
            <source src={media.store_video_url} />
          </video>
        ) : media.store_poster_url ? (
          <img src={media.store_poster_url} alt="" className="absolute inset-0 h-full w-full object-cover" aria-hidden="true" />
        ) : (
          <div className="absolute inset-0 bg-eden-surface grain" aria-hidden="true" />
        )}
        <div className="absolute inset-0 bg-eden-bg/75" aria-hidden="true" />
        <div className="container-eden relative grid gap-12 py-24 sm:py-32 lg:grid-cols-12 lg:items-center">
          <div className="max-w-2xl lg:col-span-7">
            <p className="eyebrow">{store.eyebrow}</p>
            <h1 id="loja-title" className="mt-6 text-4xl font-extrabold tracking-tight text-eden-text sm:text-5xl lg:text-6xl" data-testid="store-title">{store.title}</h1>
            <p className="mt-6 text-base leading-relaxed text-eden-secondary sm:text-lg" data-testid="store-text">{store.text}</p>
            <a href={links.tebex} target="_blank" rel="noopener noreferrer" className="btn-primary mt-10" data-testid="store-visit-button">
              {store.button_label} <ExternalLink size={16} aria-hidden="true" />
            </a>
            {store.note && (
              <p className="mt-8 flex items-start gap-2 text-sm text-eden-muted" data-testid="store-note">
                <ShieldCheck size={16} className="mt-0.5 shrink-0 text-eden-turquoise" aria-hidden="true" /> {store.note} {t("store_payments")}
              </p>
            )}
          </div>
          {list.length > 0 && (
            <div className="lg:col-span-5">
              <VipSpotlight packages={list} />
            </div>
          )}
        </div>
      </section>

      {list.length > 0 && (
        <section className="border-t border-eden-border py-20 sm:py-28" aria-labelledby="packages-title" data-testid="packages-section">
          <div className="container-eden">
            <p className="eyebrow mb-4">{t("catalog_eyebrow")}</p>
            <h2 id="packages-title" className="text-2xl font-bold tracking-tight text-eden-text sm:text-3xl lg:text-4xl">{t("catalog_title")}</h2>
            <p className="mt-4 max-w-2xl text-eden-secondary">{t("catalog_text")}</p>
            <div className="mt-12"><PackagesGrid packages={list} /></div>
          </div>
        </section>
      )}
    </>
  );
}
